<template>
  <div>
    <a-table :pagination="false" :columns="columns" size="middle" :data-source="sourceData" row-key="id">
      <template slot="user" slot-scope="record">{{ record.nickname }}</template>
      <span slot="description" slot-scope="record" class="description">{{ record }}</span>
    </a-table>
  </div>
</template>
<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: '8%',
    align: 'center'
  },
  {
    title: '用户',
    dataIndex: 'user',
    key: 'user',
    width: '10%',
    scopedSlots: { customRender: 'user' }
  },
  {
    title: '扣除分数',
    dataIndex: 'score',
    key: 'score',
    width: '10%',
    align: 'center',
    customRender: text => {
      return `${text}分`;
    }
  },
  {
    title: '责任占比',
    key: 'ratio',
    dataIndex: 'ratio',
    width: '10%',
    align: 'center',
    customRender: text => {
      return `${text}%`;
    }
  },
  {
    title: '描述',
    key: 'description',
    dataIndex: 'description',
    scopedSlots: { customRender: 'description' }
  }
];
export default {
  props: {
    sourceData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns
    };
  }
};
</script>
<style lang="less" scoped>
.description {
  white-space: pre-wrap;
}
</style>
